// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .button-plan:active {
   border: 5px solid cornflowerblue;
} */

* {
  box-sizing: border-box;
  /* justify-content: center;
   align-items: center; */
}

div.column:nth-child(1) > ul:nth-child(1) > li:nth-child(1) {
  padding-top: 89px;
}

.table {
  margin-left: auto;
  margin-right: auto;
  margin-top: 48px;
}

.column {
  float: left;
  column-width: auto;
}

/* Clear floats after the columns */
.row:after {
  content: '';
  display: table;
  clear: both;
}

/* Style the list */
.price {
  list-style-type: none;
  /* border: 1px solid var(--color-bg-mid-grey); */
  margin: 0;
  padding: 0;
  transition: 0.3s;
  margin-right: 61px;
}

.price li {
  padding: 16px;
}

/* Add shadows on hover */
.price:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}

/* Pricing header */
/* .price .header {
   color: rgb(0, 0, 0);
   font-size: 20px;
 } */

/* List items */
.price li {
  /* border-bottom: 1px solid var(--color-bg-mid-grey); */
  padding: 20px;
  text-align: left;
}

/* Grey list item */
.price .grey {
  background-color: var(--color-bg-mid-grey);
  font-size: 20px;
}

/* The "Sign Up" button */
.button {
  background-color: var(--color-success-material);
  border: none;
  color: white;
  padding: 10px 25px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
}

.featureList {
  text-align: left;
}

.amount {
  font-family: 'Inter';
  font-size: 48px;
  font-weight: 999;
  line-height: 43px;
  letter-spacing: -0.02em;
  text-align: center;
  color: var(--color-primary);
}

.amountDuration {
  font-family: Raleway;
  font-size: 16px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(29, 41, 57, 1);
}

/* Change the width of the three columns to 100%
   (to stack horizontally on small screens) */
@media only screen and (max-width: 600px) {
  .columns {
    width: 100%;
  }
}

/* p {
  font-family: Arial;
  font-size: 9px;
} */

/* .column {
   float: left;
   width: 33.33%;
 } */

/* Clear floats after the columns */
.row:after {
  content: '';
  display: table;
  clear: both;
}

.dollar:before {
  content: '\$';
  vertical-align: top;
  font-family: Raleway;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--color-primary);
  margin-right: 8px;
}

.dollarWhite:before {
  content: '\$';
  vertical-align: top;
  font-family: Raleway;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
  margin-right: 8px;
}

.timeline {
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: var(--color-primary);
}

.change-plan-wrapper .btn {
  background: var(--color-accent-violet);
  color: var(--color-white) !important;
  font-weight: 100;
  padding: 20px;
  /* text-transform: uppercase; */
  border-radius: 6px;
  display: inline-block;
  transition: all 0.3s ease 0s;
}

.change-plan-wrapper .btn:hover {
  color: var(--color-text-charcoal) !important;
  font-weight: 700 !important;
  letter-spacing: 3px;
  background: none;
  -webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  -moz-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  transition: all 0.3s ease 0s;
}

/* Animation code */
.slide-left {
  animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

/**
 * ----------------------------------------
 * animation slide-left
 * ----------------------------------------
 */

@keyframes slide-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(116px);
  }
}

.slide-right {
  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

/**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */

@keyframes slide-right {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-120px);
  }
}

/* Add this class to smoothly transition background color and text color */
.slide-right-new {
  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

/**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */

@keyframes slide-right-new {
  0% {
    background-color: 'transparent';
    background-color: 'initial';
    /* Set the initial background color */
    color: '#000';
    color: 'initial';
    /* Set the initial text color */
    transform: translateX(0);
  }

  100% {
    background-color: 'blue';
    /* Set the target background color */
    color: 'white';
    /* Set the target text color */
    transform: translateX(100px);
  }
}

/**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */
/* Add this class to smoothly transition background color and text color */
.slide-left-new {
  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-left-new {
  0% {
    background-color: 'transparent';
    background-color: 'initial';
    /* Set the initial background color */
    color: '#000';
    color: 'initial';
    /* Set the initial text color */
    transform: translateX(0);
  }

  100% {
    background-color: 'blue';
    /* Set the target background color */
    color: 'white';
    /* Set the target text color */
    transform: translateX(-100px);
  }
}

/* Corrected keyframes for .slide-l */
@keyframes slide-l {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

/* Corrected keyframes for .slide-r */
@keyframes slide-r {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

/* Apply initial styles and transition to the element with cubic-bezier timing function */
.slide-l {
  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-r {
  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.custom-tab-list div[role='tablist'] {
  display: block !important;
}

.row-wrapper {
  padding-top: 1.5rem;
}

.table-row {
  display: table-row;
}

.table-row > td {
  padding-top: 1rem;
}

@keyframes shakeJerk {
  0% {
    transform: translateX(-50%);
  }
  12.5% {
    transform: translateX(calc(-50% - 6px));
  }
  25% {
    transform: translateX(calc(-50% + 6px));
  }
  37.5%, 100% {
    transform: translateX(-50%);
  }
}

.shake-jerk-handle {
  animation: shakeJerk 1.5s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/content/billing/components/changeplan.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,sBAAsB;EACtB;yBACuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,gDAAgD;EAChD,SAAS;EAET,UAAU;EAEV,gBAAgB;EAIhB,kBAAkB;AAHpB;;AAMA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;;;IAGI;;AAEJ,eAAe;AACf;EACE,uDAAuD;EACvD,aAAa;EACb,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;6CAC6C;AAC7C;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;GAGG;;AAEH;;;IAGI;;AAEJ,mCAAmC;AACnC;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;EAC1D,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EAEE,oEAAoE;AACtE;;AAEA;;;;EAIE;;AAaF;EACE;IAEE,wBAAwB;EAC1B;;EAEA;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EAEE,qEAAqE;AACvE;;AAEA;;;;EAIE;;AAaF;EACE;IAEE,wBAAwB;EAC1B;;EAEA;IAEE,6BAA6B;EAC/B;AACF;;AAEA,0EAA0E;AAC1E;EAEE,qEAAqE;AACvE;;AAEA;;;;EAIE;;AAqBF;EACE;IACE,+BAA2B;IAA3B,2BAA2B;IAC3B,qCAAqC;IACrC,aAAgB;IAAhB,gBAAgB;IAChB,+BAA+B;IAE/B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,oCAAoC;IACpC,cAAc;IACd,8BAA8B;IAE9B,4BAA4B;EAC9B;AACF;;AAEA;;;;EAIE;AACF,0EAA0E;AAC1E;EAEE,qEAAqE;AACvE;;AAsBA;EACE;IACE,+BAA2B;IAA3B,2BAA2B;IAC3B,qCAAqC;IACrC,aAAgB;IAAhB,gBAAgB;IAChB,+BAA+B;IAE/B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,oCAAoC;IACpC,cAAc;IACd,8BAA8B;IAE9B,6BAA6B;EAC/B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yFAAyF;AACzF;EACE;qDACmD;AACrD;;AAEA;EACE;qDACmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":["/* .button-plan:active {\r\n   border: 5px solid cornflowerblue;\r\n} */\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  /* justify-content: center;\r\n   align-items: center; */\r\n}\r\n\r\ndiv.column:nth-child(1) > ul:nth-child(1) > li:nth-child(1) {\r\n  padding-top: 89px;\r\n}\r\n\r\n.table {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-top: 48px;\r\n}\r\n\r\n.column {\r\n  float: left;\r\n  column-width: auto;\r\n}\r\n\r\n/* Clear floats after the columns */\r\n.row:after {\r\n  content: '';\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n/* Style the list */\r\n.price {\r\n  list-style-type: none;\r\n  /* border: 1px solid var(--color-bg-mid-grey); */\r\n  margin: 0;\r\n  margin-right: 0px;\r\n  padding: 0;\r\n  -webkit-transition: 0.3s;\r\n  transition: 0.3s;\r\n}\r\n\r\n.price {\r\n  margin-right: 61px;\r\n}\r\n\r\n.price li {\r\n  padding: 16px;\r\n}\r\n\r\n/* Add shadows on hover */\r\n.price:hover {\r\n  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Pricing header */\r\n/* .price .header {\r\n   color: rgb(0, 0, 0);\r\n   font-size: 20px;\r\n } */\r\n\r\n/* List items */\r\n.price li {\r\n  /* border-bottom: 1px solid var(--color-bg-mid-grey); */\r\n  padding: 20px;\r\n  text-align: left;\r\n}\r\n\r\n/* Grey list item */\r\n.price .grey {\r\n  background-color: var(--color-bg-mid-grey);\r\n  font-size: 20px;\r\n}\r\n\r\n/* The \"Sign Up\" button */\r\n.button {\r\n  background-color: var(--color-success-material);\r\n  border: none;\r\n  color: white;\r\n  padding: 10px 25px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  font-size: 18px;\r\n}\r\n\r\n.featureList {\r\n  text-align: left;\r\n}\r\n\r\n.amount {\r\n  font-family: 'Inter';\r\n  font-size: 48px;\r\n  font-weight: 999;\r\n  line-height: 43px;\r\n  letter-spacing: -0.02em;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.amountDuration {\r\n  font-family: Raleway;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 38px;\r\n  letter-spacing: 0em;\r\n  text-align: center;\r\n  color: rgba(29, 41, 57, 1);\r\n}\r\n\r\n/* Change the width of the three columns to 100%\r\n   (to stack horizontally on small screens) */\r\n@media only screen and (max-width: 600px) {\r\n  .columns {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* p {\r\n  font-family: Arial;\r\n  font-size: 9px;\r\n} */\r\n\r\n/* .column {\r\n   float: left;\r\n   width: 33.33%;\r\n } */\r\n\r\n/* Clear floats after the columns */\r\n.row:after {\r\n  content: '';\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.dollar:before {\r\n  content: '$';\r\n  vertical-align: top;\r\n  font-family: Raleway;\r\n  font-size: 16px;\r\n  font-weight: 800;\r\n  line-height: 24px;\r\n  letter-spacing: 0em;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n  margin-right: 8px;\r\n}\r\n\r\n.dollarWhite:before {\r\n  content: '$';\r\n  vertical-align: top;\r\n  font-family: Raleway;\r\n  font-size: 16px;\r\n  font-weight: 800;\r\n  line-height: 24px;\r\n  letter-spacing: 0em;\r\n  text-align: center;\r\n  color: white;\r\n  margin-right: 8px;\r\n}\r\n\r\n.timeline {\r\n  font-family: 'Inter';\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 24px;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.change-plan-wrapper .btn {\r\n  background: var(--color-accent-violet);\r\n  color: var(--color-white) !important;\r\n  font-weight: 100;\r\n  padding: 20px;\r\n  /* text-transform: uppercase; */\r\n  border-radius: 6px;\r\n  display: inline-block;\r\n  transition: all 0.3s ease 0s;\r\n}\r\n\r\n.change-plan-wrapper .btn:hover {\r\n  color: var(--color-text-charcoal) !important;\r\n  font-weight: 700 !important;\r\n  letter-spacing: 3px;\r\n  background: none;\r\n  -webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);\r\n  -moz-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);\r\n  transition: all 0.3s ease 0s;\r\n}\r\n\r\n/* Animation code */\r\n.slide-left {\r\n  -webkit-animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n  animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n}\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation slide-left\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes slide-left {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(100px);\r\n    transform: translateX(100px);\r\n  }\r\n}\r\n\r\n@keyframes slide-left {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(116px);\r\n    transform: translateX(116px);\r\n  }\r\n}\r\n\r\n.slide-right {\r\n  -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n}\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation slide-right\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes slide-right {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(-100px);\r\n    transform: translateX(-100px);\r\n  }\r\n}\r\n\r\n@keyframes slide-right {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(-120px);\r\n    transform: translateX(-120px);\r\n  }\r\n}\r\n\r\n/* Add this class to smoothly transition background color and text color */\r\n.slide-right-new {\r\n  -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n}\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation slide-right\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes slide-right-new {\r\n  0% {\r\n    background-color: 'initial';\r\n    /* Set the initial background color */\r\n    color: 'initial';\r\n    /* Set the initial text color */\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    background-color: 'blue';\r\n    /* Set the target background color */\r\n    color: 'white';\r\n    /* Set the target text color */\r\n    -webkit-transform: translateX(100px);\r\n    transform: translateX(100px);\r\n  }\r\n}\r\n\r\n@keyframes slide-right-new {\r\n  0% {\r\n    background-color: 'initial';\r\n    /* Set the initial background color */\r\n    color: 'initial';\r\n    /* Set the initial text color */\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    background-color: 'blue';\r\n    /* Set the target background color */\r\n    color: 'white';\r\n    /* Set the target text color */\r\n    -webkit-transform: translateX(100px);\r\n    transform: translateX(100px);\r\n  }\r\n}\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation slide-right\r\n * ----------------------------------------\r\n */\r\n/* Add this class to smoothly transition background color and text color */\r\n.slide-left-new {\r\n  -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n}\r\n\r\n@-webkit-keyframes slide-left-new {\r\n  0% {\r\n    background-color: 'initial';\r\n    /* Set the initial background color */\r\n    color: 'initial';\r\n    /* Set the initial text color */\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    background-color: 'blue';\r\n    /* Set the target background color */\r\n    color: 'white';\r\n    /* Set the target text color */\r\n    -webkit-transform: translateX(-100px);\r\n    transform: translateX(-100px);\r\n  }\r\n}\r\n\r\n@keyframes slide-left-new {\r\n  0% {\r\n    background-color: 'initial';\r\n    /* Set the initial background color */\r\n    color: 'initial';\r\n    /* Set the initial text color */\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    background-color: 'blue';\r\n    /* Set the target background color */\r\n    color: 'white';\r\n    /* Set the target text color */\r\n    -webkit-transform: translateX(-100px);\r\n    transform: translateX(-100px);\r\n  }\r\n}\r\n\r\n/* Corrected keyframes for .slide-l */\r\n@keyframes slide-l {\r\n  0% {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(-100%);\r\n  }\r\n}\r\n\r\n/* Corrected keyframes for .slide-r */\r\n@keyframes slide-r {\r\n  0% {\r\n    transform: translateX(-100%);\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n/* Apply initial styles and transition to the element with cubic-bezier timing function */\r\n.slide-l {\r\n  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\r\n    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.slide-r {\r\n  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\r\n    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.custom-tab-list div[role='tablist'] {\r\n  display: block !important;\r\n}\r\n\r\n.row-wrapper {\r\n  padding-top: 1.5rem;\r\n}\r\n\r\n.table-row {\r\n  display: table-row;\r\n}\r\n\r\n.table-row > td {\r\n  padding-top: 1rem;\r\n}\r\n\r\n@keyframes shakeJerk {\r\n  0% {\r\n    transform: translateX(-50%);\r\n  }\r\n  12.5% {\r\n    transform: translateX(calc(-50% - 6px));\r\n  }\r\n  25% {\r\n    transform: translateX(calc(-50% + 6px));\r\n  }\r\n  37.5%, 100% {\r\n    transform: translateX(-50%);\r\n  }\r\n}\r\n\r\n.shake-jerk-handle {\r\n  animation: shakeJerk 1.5s ease-in-out infinite;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
